import React from 'react'
import NavigationTabs from '../NavigationTabs/NavigationTabs'

export default function Subheader() {
  return <NavigationTabs />
}
